import React from 'react'
import ReactMarkdown from 'react-markdown'
import Image from 'next/legacy/image'
import PropTypes from 'prop-types'

export default function DetailsWithPhoto({ details, image }) {
  if (!details) return null
  const photo = image?.file.data[0] ? image : null
  const description = details.split('\n')
  const lis = []

  for (let i = 1; i < details.length; i += 1) {
    lis.push(<ReactMarkdown key={i}>{description[i]}</ReactMarkdown>)
  }

  const myLoader = ({ src }) => src

  return (
    <div>
      <ReactMarkdown>{description[0]}</ReactMarkdown>
      {photo ? (
        <Image
          loader={myLoader}
          src={photo.file.data[0].attributes.url}
          height={900}
          width={1200}
          layout="responsive"
        />
      ) : null}
      {lis}
    </div>
  )
}

DetailsWithPhoto.propTypes = {
  details: PropTypes.string.isRequired,
}
